import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CountryImportDTO  {
    _originalTypeClassName = "zERP.BO.CountryImportDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CountryImportDTO.translate = translateService;
}
this.cca2 = null;
this.cca3 = null;
this.CountryImportDTOKey = null;
this._key = this.CountryImportDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
cca2:any;
cca3:any;
name:any;
private _CountryImportDTOKey:any;
get CountryImportDTOKey(): any {
    return this._CountryImportDTOKey;
  }
set CountryImportDTOKey(value: any) {
    this._CountryImportDTOKey = value;
    this._key = value;
  }
static setname = ($this, value) => {
var oldValue = $this.name;
$this.name = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CountryImportDTOKey == null || $this.CountryImportDTOKey == 0;
            }


}